module.exports = "<bs-navbar></bs-navbar>\n<div style=\"margin-top:40px;\"class=\"container\">\n <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main